import React from 'react';
import { Box, Typography } from '@mui/material';
import {
  Gavel as GavelIcon,
  Description as DescriptionIcon,
  CalendarToday as CalendarIcon,
  Receipt as ReceiptIcon,
  AttachMoney as MoneyIcon,
  Event as EventIcon,
} from '@mui/icons-material';
import { ClientStats } from '../../../types/statistics';
import { StatCard } from '../StatCard';
import { DashboardTabs } from '../DashboardTabs';

interface ClientViewProps {
  data: ClientStats;
}

export const ClientView: React.FC<ClientViewProps> = ({ data }) => {
  if (data.message) {
    return (
      <Box sx={{ textAlign: 'center', py: 8 }}>
        <Typography variant="h6" color="text.secondary">
          {data.message}
        </Typography>
      </Box>
    );
  }

  return (
    <DashboardTabs overviewType="client">
      <Box sx={{ display: 'flex', flexWrap: 'wrap', mx: -1.5 }}>
        <Box sx={{ width: { xs: '100%', sm: '50%', md: '25%' }, p: 1.5 }}>
          <StatCard
            title="My Cases"
            value={data.my_cases}
            icon={<GavelIcon />}
            color="#2563eb"
          />
        </Box>
        <Box sx={{ width: { xs: '100%', sm: '50%', md: '25%' }, p: 1.5 }}>
          <StatCard
            title="Active Cases"
            value={data.active_cases}
            icon={<GavelIcon />}
            color="#16a34a"
          />
        </Box>
        <Box sx={{ width: { xs: '100%', sm: '50%', md: '25%' }, p: 1.5 }}>
          <StatCard
            title="Completed Cases"
            value={data.completed_cases}
            icon={<DescriptionIcon />}
            color="#9333ea"
          />
        </Box>
      </Box>

      <Box sx={{ display: 'flex', flexWrap: 'wrap', mx: -1.5 }}>
        <Box sx={{ width: { xs: '100%', sm: '50%', md: '25%' }, p: 1.5 }}>
          <StatCard
            title="Pending Tasks"
            value={data.pending_tasks}
            icon={<DescriptionIcon />}
            color="#2563eb"
          />
        </Box>
        <Box sx={{ width: { xs: '100%', sm: '50%', md: '25%' }, p: 1.5 }}>
          <StatCard
            title="Upcoming Hearings"
            value={data.upcoming_hearings}
            icon={<CalendarIcon />}
            color="#9333ea"
          />
        </Box>
        {data.next_hearing_date && (
          <Box sx={{ width: { xs: '100%', sm: '50%', md: '25%' }, p: 1.5 }}>
            <StatCard
              title="Next Hearing"
              value={data.next_hearing_date}
              icon={<EventIcon />}
              color="#dc2626"
            />
          </Box>
        )}
      </Box>

      <Box sx={{ display: 'flex', flexWrap: 'wrap', mx: -1.5 }}>
        <Box sx={{ width: { xs: '100%', sm: '50%', md: '25%' }, p: 1.5 }}>
          <StatCard
            title="Total Bills"
            value={data.total_bills}
            icon={<ReceiptIcon />}
            color="#2563eb"
          />
        </Box>
        <Box sx={{ width: { xs: '100%', sm: '50%', md: '25%' }, p: 1.5 }}>
          <StatCard
            title="Unpaid Bills"
            value={data.unpaid_bills}
            icon={<ReceiptIcon />}
            color="#dc2626"
          />
        </Box>
        <Box sx={{ width: { xs: '100%', sm: '50%', md: '25%' }, p: 1.5 }}>
          <StatCard
            title="Outstanding Balance"
            value={data.outstanding_balance}
            icon={<MoneyIcon />}
            color="#9333ea"
          />
        </Box>
      </Box>
    </DashboardTabs>
  );
};
